import {components} from "react-select";
import styled from "styled-components";
import {whiteTransparent} from "../../Theme";

export const OptionWithDivider = (props) => {
    const {data, options} = props;
    const isLastOption = options.indexOf(data) === options.length - 1;

    return (
        <OptionWrapper>
            <components.Option {...props} />
            <Divider $isLastOption={isLastOption} />
        </OptionWrapper>
    );
};

const OptionWrapper = styled.div`
    margin: 0 12px;
    overflow-x: hidden;
`;

const Divider = styled.hr`
    width: 100%;
    margin: 0;
    border: 1px solid ${props => props.$isLastOption ? 'transparent' : whiteTransparent};
`;